import { Icon } from "@/components/BaseComponents/Icon";

export const DiscountIcon = (props) => (
	<Icon fill="none" {...props}>
		<path
			d="M19 15l3-3-3-3V5h-4l-3-3-3 3H5v4l-3 3 3 3v4h4l3 3 3-3h4v-4ZM15 9l-6 6"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<circle cx="9.5" cy="9.5" r="1.5" fill="currentColor" />
		<circle cx="14.5" cy="14.5" r="1.5" fill="currentColor" />
	</Icon>
);
